// extracted by mini-css-extract-plugin
export var content = "_n7-1";
export var fullScreen = "_n7-0";